module.exports = __webpack_public_path__ + "media/src/img/uni/mir-68ca71e68f0fb7bd4e7d67476d7bb9b3.svg";